import { render, staticRenderFns } from "./AgedBalanceTable.vue?vue&type=template&id=5be034d9&"
import script from "./AgedBalanceTable.vue?vue&type=script&lang=js&"
export * from "./AgedBalanceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports